import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import ComponentHeader from 'common/components/ComponentHeader';
import { BulkAddUsersContext } from 'common/contexts';
import NewMemberForm from './components/NewMemberForm';
import { bulkAddUsersPageHeaderStyles } from '../styles';
import AddMembersButton from './components/AddMembersButton';

import styles from './EditorContainer.module.scss';

const HeaderTab = ({ text, width }) => (
  <div className={styles.headerTab} style={{ width }}>
    {text}
  </div>
);
HeaderTab.propTypes = { text: PropTypes.string.isRequired, width: PropTypes.string.isRequired };

const EditorContainer = () => {
  const { newMembers, setNewMembers } = useContext(BulkAddUsersContext);
  const removeUser = ind => {
    const newMembersList = [...newMembers];
    newMembersList.splice(ind, 1);
    return setNewMembers(newMembersList);
  };

  const setAttribute = ({ attributeType, attributeValue, ind }) => {
    const newMembersList = [...newMembers];
    if (newMembersList[ind]) {
      const memberToEdit = newMembersList[ind];
      memberToEdit[attributeType] = attributeValue;
    } else {
      newMembersList[ind] = {};
      newMembersList[ind][attributeType] = attributeValue;
    }
    if (ind === newMembersList.length - 1) {
      newMembersList.push({});
    }
    return setNewMembers(newMembersList);
  };

  return (
    <>
      <ComponentHeader styles={bulkAddUsersPageHeaderStyles}>
        <HeaderTab text="Name" width="30vw" />
        <HeaderTab text="Phone" width="15vw" />
        <HeaderTab text="Gender" width="15vw" />
        <HeaderTab text="Peer Class" width="15vw" />
      </ComponentHeader>
      <div className={styles.editorRowDisplay}>
        <div>
          {newMembers.map((newMember, ind) => (
            <NewMemberForm
              gender={newMember.gender}
              ind={ind}
              key={ind} // eslint-disable-line react/no-array-index-key
              name={newMember.name}
              peerClass={newMember.peer_class}
              phone={newMember.cell_phone}
              removeUser={removeUser}
              setAttribute={setAttribute}
            />
          ))}
        </div>
        <AddMembersButton />
      </div>
    </>
  );
};

export default EditorContainer;
